import { render } from "./createColumnTab.vue?vue&type=template&id=3782663b"
import script from "./createColumnTab.vue?vue&type=script&lang=js"
export * from "./createColumnTab.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./createColumnTab.less?vue&type=style&index=0&module=true&lang=less&external"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__